import { render } from "./ExternalPatientChangeEmailOffcanvas.vue?vue&type=template&id=ce3dc8c4&scoped=true"
import script from "./ExternalPatientChangeEmailOffcanvas.vue?vue&type=script&lang=js"
export * from "./ExternalPatientChangeEmailOffcanvas.vue?vue&type=script&lang=js"

import "./ExternalPatientChangeEmailOffcanvas.vue?vue&type=style&index=0&id=ce3dc8c4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce3dc8c4"]])

export default __exports__